import React from "react";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import EventDetail from "../../components/global/Event/EventDetail";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import { getEvent } from "../../lib/eventRequests";
import { isBefore } from "date-fns";

export default function EventsPage({event, hasPast, error}) {
  return (
    <Layout disableMeta={true}>
      <Header></Header>
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <EventDetail event={event} hasPast={hasPast} error={error}/>
    </Layout>
  );
}

export const getServerSideProps = async (context) => {
  try {
    const query = context.query;
    const slug = query.slug || [];
    const eventId = slug[0];

    const { data } = await getEvent(eventId as string);
    
    if (!data) {
      return {
        notFound: true,
      };
    }

    const endDate = data.end_date;
    const date = data.date;
    const eventDate = endDate || date;
    const hasPast = eventDate
      ? isBefore(new Date(eventDate.replace(/-/g, '/')), new Date())
      : true;

    return {
      props: {
        event: data,
        hasPast 
      },
    };
  } catch (error) {
    console.error("Error fetching event details:", error);
    if (error.data?.status === 404) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        error: `Failed to load event details: ${error.message}`,
      },
    }

    
  }
}
